if ( typeof ReassuranceSlider !== 'function' ) {

  class ReassuranceSlider extends HTMLElement {

    constructor() {

      super();

      this.slider = this.querySelector('[data-js-slider]');
      this.content = this.querySelectorAll('.reassurance-slider__item');
      this.nextButton = this.querySelector('.reassurance-slider__content-nav--right');
      this.prevButton = this.querySelector('.reassurance-slider__content-nav--left');

      this.index = 0;
      this.length = this.content.length;

      this.enableAnimation = this.slider.getAttribute('data-slider-animation');
      this.animationSpeed = this.slider.getAttribute('data-slider-animation-speed') * 1000;

      if(this.enableAnimation === 'true') {
        this.intervalID = setInterval(() => this.swipeSlider(), this.animationSpeed);
      }
      
      if ( this.nextButton ) {
        this.nextButton.addEventListener('click', ()=>{
          if(this.enableAnimation === 'true') {
            clearInterval(this.intervalID);
            this.intervalID = setInterval(() => this.swipeSlider(), this.animationSpeed);
          }

          this.changeSlide('next');
        });
      }
      if ( this.prevButton ) {
        this.prevButton.addEventListener('click', ()=>{
          if(this.enableAnimation === 'true') {
            clearInterval(this.intervalID);
            this.intervalID = setInterval(() => this.swipeSlider(), this.animationSpeed);
          }

          this.changeSlide('prev');
        });
      }
    }

    changeSlide(direction) {

      this.nextButton.classList.remove('reassurance-slider__content-nav--disabled')
      this.prevButton.classList.remove('reassurance-slider__content-nav--disabled')

      if ( direction == 'next' ) {
        this.index++;
      } else if ( direction == 'prev' ) {
        this.index--;
      }

      if ( this.index == this.length - 1 ) {
        this.nextButton.classList.add('reassurance-slider__content-nav--disabled');
        this.prevButton.classList.remove('reassurance-slider__content-nav--disabled');
      } else if ( this.index == 0 ) {
        this.prevButton.classList.add('reassurance-slider__content-nav--disabled');
        this.nextButton.classList.remove('reassurance-slider__content-nav--disabled');
      } else {
        this.nextButton.classList.remove('reassurance-slider__content-nav--disabled');
        this.prevButton.classList.remove('reassurance-slider__content-nav--disabled');
      }

      this.slider.scrollTo({
        top: 0,
        left: this.content[this.index].offsetLeft,
        behavior: 'smooth'
      });

    }

    swipeSlider() {
      this.index++;
      if ( this.index == this.length ) {
        this.index = 0;
      }

      if ( this.index == this.length - 1 ) {
        this.nextButton.classList.add('reassurance-slider__content-nav--disabled');
        this.prevButton.classList.remove('reassurance-slider__content-nav--disabled');
      } else if ( this.index == 0 ) {
        this.prevButton.classList.add('reassurance-slider__content-nav--disabled');
        this.nextButton.classList.remove('reassurance-slider__content-nav--disabled');
      } else {
        this.nextButton.classList.remove('reassurance-slider__content-nav--disabled');
        this.prevButton.classList.remove('reassurance-slider__content-nav--disabled');
      }

      this.slider.scrollTo({
        top: 0,
        left: this.content[this.index].offsetLeft,
        behavior: 'smooth'
      });
    }

  }

  if ( typeof customElements.get('reassurance-slider') == 'undefined' ) {
    customElements.define('reassurance-slider', ReassuranceSlider);
  }

}